import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { library as fontAwesome } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faCaretDown, faComments } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import Settings from '../features/Settings'
import styles from './app.scss'
import TitleBar from '../containers/TitleBar'
import SideMenu from '../containers/SideMenu'
import MainSection from '../containers/MainSection'
import LoadingBar from '../features/LoadingBar'
import Sync from '../features/Sync'
import ProfileSelector from '../features/ProfileSelector'
import Eula from '../features/Eula'
import Rating from '../components/Rating'
import Toaster from '../features/Toaster'
import Backend from '../features/Backend'

fontAwesome.add(faCog, faCaretDown, faComments, fab)
// import ToastTest from './ToastTest'

class App extends Component {
    // Look for the steam_ticket query parameter, and if it contains
    // any text we assume it as a steam launch
    static validateIfSteam(steamTicket) {
        if (steamTicket !== undefined) return true
        return false
    }

    componentDidMount() {
        if (this.props.isAutoLaunchEnabled()) {
            this.props.setAutoLaunchEnabledState(true)
            this.props.setAutoLaunchUrlParameter()
        } else {
            this.props.setAutoLaunchEnabledState(false)
        }
        this.props.javaScriptReady()
    }

    renderRating = () => (this.props.showRatings ? <Rating /> : null)

    render() {
        if (!this.props.isBackendReady) {
            return (
                <React.Fragment>
                    <div className={styles.spinner}>
                        <FontAwesomeIcon icon="cog" size="5x" spin />
                    </div>
                    <Backend />
                </React.Fragment>
            )
        }

        try {
            const view = this.props.showSettings ? <Settings /> : <MainSection />
            const profileSelector = this.props.showProfileSelector ? <ProfileSelector /> : null

            return (
                <div id="ccp-launcher">
                    <TitleBar />
                    <div id={styles.launcher}>
                        <SideMenu />
                        {view}
                    </div>
                    <LoadingBar />
                    <Sync />
                    {profileSelector}
                    <Eula />
                    {this.renderRating()}
                    <Toaster />
                    <Backend />
                </div>
            )
        } catch (error) {
            console.info(`An error occurred while rendering app: ${error.message}`)
        }
    }
}

App.propTypes = {
    isBackendReady: PropTypes.bool,
    showSettings: PropTypes.bool,
    showProfileSelector: PropTypes.bool,
    isAutoLaunchEnabled: PropTypes.func,
    setAutoLaunchUrlParameter: PropTypes.func,
    setAutoLaunchEnabledState: PropTypes.func,
    javaScriptReady: PropTypes.func,
    showRatings: PropTypes.bool,
}

export default App



// WEBPACK FOOTER //
// ./src/App/app.js